import React, { Component } from 'react';
import AllUsers from './AllUsers';

class ChildAccounts extends Component {
  render() {
    return <AllUsers childAccounts={true}></AllUsers>;
  }
}

export default ChildAccounts;
